import { B2B_CHECKOUT_PAGE_KEY } from '../constants';

const es = {
  [B2B_CHECKOUT_PAGE_KEY]: {
    NAME_LABEL: 'Nombre',
    REQUIRED_FIELD: 'Campo requerido',
    REQUIRED_NAME: 'Nombre requerido',
    INVALID_NAME: 'El nombre es inválido',
    LAST_NAME_LABEL: 'Apellido',
    REQUIRED_LAST_NAME: 'Apellido requerido',
    INVALID_LAST_NAME: 'El apellido es inválido',

    // Payment errors
    INSUFFICIENT_FUNDS:
      'Nuestro sistema nos indica que tienes fondos insuficientes.',
    EXPIRED_CARD: 'Tu tarjeta ha expirado, comunícate con tu banco.',
    INVALID_INFO_CARD: 'Tu tarjeta es incorrecta, intentalo de nuevo',
    INVALID_CARD: 'Tu tarjeta es inválida, intentalo de nuevo',
    CATCH_MESSAGE: '¡El pago no puede ser procesado!, inténtalo otra vez',
  },
};

export default es;
